import { ROOT_URL } from '../actions';

export const shipmentApi = {
  CREATE_SHIPMENT: `${ROOT_URL}/hms/create_shipment/`,
  CANCEL_SHIPMENT: `${ROOT_URL}/hms/cancel_shipment/`,
  CARGOS: `${ROOT_URL}/hms/cargos/`,
  UPDATE_SHIPMENT: `${ROOT_URL}/hms/update_shipment/`,
  REMOVE_FROM_SHIPMENT: `${ROOT_URL}/hms/remove_from_shipment/`,
  CREATE_RETURN_SHIPMENT: `${ROOT_URL}/hms/create_return_shipment/`
}